module.exports = __webpack_public_path__ + "static/media/zwz_india_hindu.f0540d3c.pdf";